import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import Logo from "@/components/Logo";

const Footer = () => (
  <footer className="bg-ink text-bone relative z-10" data-testid="site-footer">
    <div className="container-x py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
      <div className="md:col-span-5">
        <div className="mb-6"><Logo dark className="h-12 md:h-14" /></div>
        <p className="text-sm text-bone/70 leading-relaxed max-w-sm">
          Real Estate Development
          <br />
          Eastern Ontario
        </p>
      </div>
      <div className="md:col-span-3">
        <p className="text-xs tracking-[0.25em] uppercase font-semibold text-bone/50 mb-5">Navigate</p>
        <ul className="space-y-3 text-sm">
          <li><Link to="/projects" className="text-bone/80 hover:text-bone transition-colors duration-300" data-testid="footer-nav-projects">Projects</Link></li>
          <li><Link to="/invest-with-us" className="text-bone/80 hover:text-bone transition-colors duration-300" data-testid="footer-nav-invest">Invest With Us</Link></li>
          <li><Link to="/about" className="text-bone/80 hover:text-bone transition-colors duration-300" data-testid="footer-nav-about">About</Link></li>
          <li><Link to="/contact" className="text-bone/80 hover:text-bone transition-colors duration-300" data-testid="footer-nav-contact">Contact</Link></li>
        </ul>
      </div>
      <div className="md:col-span-4">
        <p className="text-xs tracking-[0.25em] uppercase font-semibold text-bone/50 mb-5">Contact</p>
        <a
          href="mailto:info@stelcoredevelopment.com"
          className="inline-flex items-center gap-2 text-sm text-bone/80 hover:text-bone transition-colors duration-300"
          data-testid="footer-email-link"
        >
          <Mail size={14} /> info@stelcoredevelopment.com
        </a>
        <ul className="space-y-3 text-sm mt-6">
          <li><Link to="/privacy-policy" className="text-bone/60 hover:text-bone transition-colors duration-300" data-testid="footer-privacy-link">Privacy Policy</Link></li>
          <li><Link to="/legal-disclaimer" className="text-bone/60 hover:text-bone transition-colors duration-300" data-testid="footer-disclaimer-link">Legal Disclaimer</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-bone/10">
      <div className="container-x py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <p className="text-xs text-bone/50">© {new Date().getFullYear()} Stelcore Development All rights reserved.</p>
        <p className="text-xs text-bone/40 max-w-2xl">
          This website is for informational purposes only and does not constitute an offer to sell securities,
          an investment recommendation, or a guarantee of profit, development approval or land value.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
